import { useReportError } from '~/hooks/useReportError';
import { useQuery, useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { getLabelsRequest } from '~/api/dashboard/getLabelsRequest';
export const labelsQueryKey = 'labels';
export function useLabelsQuery({ currentLabelsPage }) {
    console.log(currentLabelsPage);
    const reportError = useReportError();
    const queryClient = useQueryClient();
    const query = useQuery([labelsQueryKey], () => {
        return getLabelsRequest();
    }, {
        onError: (error) => {
            reportError('Unable to fetch labels for dashboard', error);
        },
        refetchOnWindowFocus: true,
        refetchOnMount: true, // Refetch when the component mounts
    });
    const invalidateQuery = useCallback(() => {
        queryClient.invalidateQueries(labelsQueryKey);
    }, [queryClient]);
    return {
        query,
        invalidateQuery,
    };
}
